<template>
  <div
    id="app"
    :class="!isAdmin || 'is-admin'"
  >
    <app-header
      :class="{ 'long-title-menu-down': isAdmin || ($route.name == 'faq' && !isLoggedIn) || (!isAdmin && (anyNonOpen || openAttentionCases))}"
      app-title="Lead Certification Submission System"
      app-subtitle="Lead and Healthy Homes Program"
    >
      <template v-slot:mobile-menu>
        <mobile-menu>
          <nav-bar-menu />
        </mobile-menu>
      </template>
      <nav-bar-menu />
    </app-header>
    <main class="main has-background-white p-b-lg">
      <div
        v-if="$route.name === 'home' && openAttentionCases && !$store.getters['users/unfinished']"
        class="notification is-warning m-b-none content"
      >
        <div class="container">
          <div class="column p-t-none p-b-none content">
            <p>
              We have identified <strong>{{ openAttentionCases }}</strong> problems in one or more of your submitted Lead Disclosures that require immediate attention. Please go to <router-link :to="{ name: 'cases' }">
                Case Management
              </router-link> to solve these issues.
            </p>
          </div>
        </div>
      </div>
      <div
        v-if="$route.name === 'home' && $store.getters['users/unfinished']"
        class="notification is-warning m-b-none content"
      >
        <p>
          Your mailing information are required before submitting your Lead Certification documents. 
          Please proceed to update your
          <router-link :to="{ name: 'profile' }">
            profile details
          </router-link> before continuing.
        </p>
      </div>
      <router-view />
      <!-- <div class="container">
      </div> -->
    </main>
    <app-footer
      class="p-t-sm p-b-sm"
      :links="footerLinks"
    />

    <!-- Modals -->
    <custom-dialog />
    
    <!-- <contact-us /> -->
  </div>
</template>

<script>
import NavBarMenu from '@/components/NavBarMenu';
import CustomDialog from '@/components/modals/CustomDialog';
// import ContactUs from '@/components/ContactUs';

export default {
  name: "DefaultLayout",
  components: {
    NavBarMenu,
    CustomDialog,
    // ContactUs,
  },
  data() {
    return {
      footerLinks: [
        {
          text: 'Terms of use',
          href: this.showTermsAndConditions,
          attrs: {
            href: "#",
            tabindex: "0",
          },
        },
        {
          text: 'Contact us',
          href: '/contact-us',
          attrs: {
            tabindex: "0",
            target: "_blank",
          },
        },
        {
          text: 'FAQ',
          href: '/faq',
          attrs: {
            tabindex: "0",
            target: "_blank",
          },
        },
      ],
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.auth.isAuthenticated;
    },
  },
  async beforeMount() {
    if (this.isLoggedIn) {
      return await this.$store.dispatch('users/getMe');
    }
  },
};
</script>

